// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5e6f5740","703":"6edf46b7"}[chunkId] + ".chunk.js";
};